import { barrage, meeting as meetingModel } from '@/models';
import webModels from '@/web/models';
import { useLocalStore, useObserver } from 'mobx-react';
import { useCallback, useEffect, useState } from 'react';
import { Lang } from '@/types/lang';

export const useBarrage = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const { stomp } = useLocalStore(() => webModels);
  const meeting = useLocalStore(() => meetingModel);
  const [connectError, setConnectError] = useState<boolean>(false);
  const [subscribeId, setSubscriptionId] = useState<string>();
  const [subscribeDes, setSubscribeDes] = useState<string>();
  const [resMsg, setResMsg] = useState<any>();
  const { channelId } = useObserver(() => {
    return {
      channelId: meeting.info?.channelId,
    };
  });

  const connect = useCallback((linked: boolean) => {
    setConnectError(false);
    setLoading(true);
    stomp.setStartedConnected(linked);
  }, []);

  // 拿到会议idchannelId 开始建立stomp链接

  const initConnect = useCallback(() => {
    const translateTargetLanguage = barrage.targetLang === Lang.auto ? '' : barrage.targetLang;
    stomp.initConnect(() => {
      return API.api.webSubtitleV3.turnOnSubtitle
        .request(
          { meetingId: window.$meetingId },
          {
            channelId,
            language: barrage.originLang,
            translate: barrage.translate,
            translateTargetLanguage,
          }
        )
        .then((res) => {
          const { subscriptionId, stompDestination } = res.data;
          setSubscriptionId(subscriptionId);
          setSubscribeDes(stompDestination);
          return res;
        })
        .catch((err) => {
          setConnectError(true);
          stomp.setStartedConnected(false);
        });
    });
  }, [barrage, channelId]);

  useEffect(() => {
    // 初始化订阅
    if (barrage.barrageVisible && stomp.startedConnected && channelId) {
      initConnect();
    }
  }, [stomp.startedConnected, channelId, barrage.barrageVisible]);

  useEffect(() => {
    if (!barrage.barrageVisible) {
      subscribeId && stomp?.unSubscribe(subscribeId);
      stomp.disconnect();
      setSubscribeDes('');
      setSubscriptionId('');
    }
  }, [barrage.barrageVisible]);

  useEffect(() => {
    if (barrage.translate) {
      const translateTargetLanguage = barrage.targetLang === Lang.auto ? '' : barrage.targetLang;
      const translate = barrage.targetLang === Lang.auto ? false : true;
      API.api.webSubtitleV3.switchLanguage
        .request(
          { meetingId: window.$meetingId },
          {
            channelId,
            language: barrage.originLang,
            translate,
            translateTargetLanguage,
            subscriptionId: subscribeId,
          }
        )
        .then((res) => {
          if (res && res.status === 1) {
            const { stompDestination, subscriptionId } = res.data;
            stomp.unSubscribe(subscribeId);
            setSubscribeDes(stompDestination);
            setSubscriptionId(subscriptionId);
          }
        });
    }
  }, [barrage.originLang, barrage.translate, barrage.targetLang]);

  useEffect(() => {
    if (subscribeDes && stomp.connected && subscribeId)
      setTimeout(() => {
        stomp.subscribe(
          subscribeDes,
          (data: any) => {
            setResMsg(data);
          },
          subscribeId
        );
      }, 500);
  }, [stomp.connected, subscribeDes, subscribeId]);

  return useObserver(() => {
    return {
      connect,
      connectError: connectError,
      resMsg,
      connected: stomp.connected,
    };
  });
};
